import { Tab, Tabs } from '@mui/material';
import { useRouter } from 'next/router';
import { ReactNode, SyntheticEvent } from 'react';

interface Props {
  children: ReactNode;
  selectedTab: string;
}

export const SettingsTabs = ({ children, selectedTab }: Props) => {
  const router = useRouter();

  const onTabChange = (_: SyntheticEvent, newTab: string) => {
    router.push({
      pathname: `/settings/${newTab}`,
    });
  };

  return (
    <div className="p-6 max-w-screen-xl m-auto">
      <Tabs
        textColor="primary"
        indicatorColor="primary"
        aria-label="tabs"
        value={selectedTab}
        className="border-b mb-6"
        onChange={onTabChange}
        variant="scrollable"
      >
        <Tab label="Profile" value="" />
        <Tab label="Login" value="login" />
        <Tab label="Accounts" value="accounts" />
        <Tab label="Notifications" value="notifications" />
      </Tabs>
      {children}
    </div>
  );
};
